import { type IPostCandidatesSearch, useSearchCandidatesSuspense } from "@api";
import type { ObjectId } from "@bbj-types/utils";
import { Stack } from "@mui/material";
import { type Dispatch, type MutableRefObject, type SetStateAction, useMemo } from "react";
import { formatSendFilterSearchCandidate } from "../filters/logics";
import type { IAddParticipantFilters } from "../filters/types";
import { CandidateSelectionTabs } from "./candidateSelectionTabs";
import type { TCurrentTab } from "./chipsBar";

export interface IModalSelectCandidatesListsProps {
  filters: IAddParticipantFilters;
  currentTab: TCurrentTab;
  disabledCandidates?: { _id: ObjectId; tooltip?: string }[];
  selectedCandidates: IPostCandidatesSearch["data"];
  localSelectedCandidates: IPostCandidatesSearch["data"];
  setSelectedCandidates: Dispatch<SetStateAction<IPostCandidatesSearch["data"]>>;
  setLocalSelectedCandidates: Dispatch<SetStateAction<IPostCandidatesSearch["data"]>>;
  setTotal: Dispatch<SetStateAction<number>>;
  scrollerRef: MutableRefObject<HTMLDivElement | null>;
}

export const ModalSelectCandidatesLists = ({
  filters,
  currentTab,
  disabledCandidates,
  selectedCandidates,
  localSelectedCandidates,
  setSelectedCandidates,
  setLocalSelectedCandidates,
  setTotal,
  scrollerRef,
}: IModalSelectCandidatesListsProps) => {
  const memoizedFilters = useMemo(() => {
    return formatSendFilterSearchCandidate(filters);
  }, [filters]);
  const findCandidateWorkshop = useSearchCandidatesSuspense(memoizedFilters);

  return (
    <Stack sx={{ flex: "auto" }}>
      <CandidateSelectionTabs
        currentTab={currentTab}
        selectedCandidates={selectedCandidates}
        localSelectedCandidates={localSelectedCandidates}
        disabledCandidates={disabledCandidates}
        setTotal={setTotal}
        hasFilters={!!Object.keys(memoizedFilters).length}
        setSelectedCandidates={setSelectedCandidates}
        setLocalSelectedCandidates={setLocalSelectedCandidates}
        findCandidateWorkshop={findCandidateWorkshop}
        scrollerRef={scrollerRef}
      />
    </Stack>
  );
};
